export default "__VITE_ASSET__Cr4MzfxT__"